export const AVATAR_UPLOAD_PLACEHOLDER = 'Click to upload image';
export const TITLE_ROW_COUNT = 2;
export const MAX_TITLE_COUNT = 3;
export const INTRODUCTION_MAX_LENGTH = 600;
export const INTRODUCTION_EN_MAX_LENGTH = 600;
export const TITLE_MAX_COUNT_MESSAGE = 'Maximum of 3 titles allowed';

export const MEETING_TITLE = 'SUSTAINABLE SOCIAL VALUE INNOVATION SUMMIT 2026';
export const MEETING_DESCRIPTION =
  'Launched in 2024, the Sustainable Social Value Innovation Summit (S Summit) is co-hosted by the Tencent Sustainable Social Value Organization, the United Nations in China, the China Enterprise Reform and Development Society, and the Tsinghua University Institute for Sustainable Social Value, among other key partners. The Summit serves as an open, global platform dedicated to highlighting corporate impact in sustainable development and fostering a thriving social value ecosystem.';

export const HERO_TITLE = 'SUSTAINABLE SOCIAL VALUE INNOVATION SUMMIT 2026';
export const HERO_SUBTITLE = 'AI FOR GOOD·SOCIAL INNOVATION';
export const MEETING_DATE_TEXT = 'December 3, 2026';
export const MEETING_LOCATION_TEXT =
  'Zhongguancun International Innovation Center, Haidian District, Beijing, China';
export const COPYRIGHT_TEXT =
  'Copyright @ 2021-2022 Tencent. All Rights Reserved';

export const PAGE_LOADING_TEXT = 'Loading page';
export const SUBMIT_LOGIN_REQUIRED_MESSAGE = 'Please log in before submitting.';
export const AVATAR_UPLOAD_REQUIRED_MESSAGE =
  'Please upload your profile picture before submitting.';
export const SUBMIT_SUCCESS_MESSAGE = 'Submitted successfully.';
export const PROFILE_UPDATE_SUBMIT_SUCCESS_MESSAGE =
  'Submitted successfully. Waiting for review.';
export const PROFILE_UPDATE_NO_CHANGE_MESSAGE =
  'No changes detected. No review request was submitted.';
export const DUPLICATE_REGISTER_MESSAGE = 'You have already registered';
export const EDIT_BUTTON_TEXT = 'Edit';
export const PROFILE_UPDATE_REVIEWING_BUTTON_TEXT =
  'Information update under review';
export const DESKTOP_SUBMIT_BUTTON_TEXT = 'Confirm Submission';
export const MOBILE_SUBMIT_BUTTON_TEXT = 'Submit';
export const CANCEL_BUTTON_TEXT = 'Cancel';
export const SUCCESS_TITLE = 'Submitted successfully';
export const BASIC_INFO_TITLE = 'Personal Details';

export const FIRST_NAME_LABEL = 'First Name';
export const LAST_NAME_LABEL = 'Last Name';
export const CHINESE_NAME_LABEL = 'Chinese Name (optional)';
export const PROFILE_PICTURE_LABEL = 'Profile Picture';
export const AVATAR_LABEL_MOBILE = 'Profile Picture';
export const NATIONALITY_LABEL = 'Country/Region (optional)';
export const EMAIL_LABEL = 'Email';
export const ORGANIZATION_LABEL = 'Organization / Institution / Employer';
export const POSITION_LABEL = 'Position';
export const PERSONAL_PROFILE_LABEL = 'Personal Profile';
export const ENGLISH_PROFILE_LABEL = 'English Profile';
export const CHINESE_PROFILE_LABEL = 'Chinese Profile';
export const CONTACT_PERMISSION_LABEL =
  'Allow contact via platform messages (Receive in-site notifications, connection requests, messages, and other information about the summit)';
export const CONTACT_ALLOW_TEXT = 'Allow';
export const CONTACT_DECLINE_TEXT = 'Decline';
export const CONTACT_PERMISSION_REQUIRED_MESSAGE =
  'Please choose whether we may contact you via platform messages.';

export const PROFILE_PICTURE_REQUIRED_MESSAGE =
  'Please upload your profile picture.';
export const PROFILE_PICTURE_PROMPT =
  'Please upload a clear, recent headshot. Max file size: 2MB.';
export const TITLE_ADD_BUTTON_TEXT = 'Add Title';
export const TITLE_DELETE_ARIA_LABEL = 'Delete title';
export const TITLE_EN_PLACEHOLDER = 'Additional Title in English (optional)';
export const TITLE_CN_PLACEHOLDER = 'Additional Title in Chinese (optional)';
export const GENERAL_INPUT_PLACEHOLDER = 'Please enter content';
export const MOBILE_INPUT_PLACEHOLDER = 'Please enter content';
export const BIO_ZH_PLACEHOLDER =
  'Please provide a Chinese version of your bio. Al-generated translations are welcome. (Max 600 characters)';
export const BIO_EN_PLACEHOLDER =
  'Please insert your personal bio in English. (Max 600 characters)';
export const PUBLIC_DISPLAY_NOTICE_TEXT =
  'Please note that the information you provide (photo, name, company, job title, and biography) will be published on the SSV website and displayed within our networking features.';
export const MOBILE_FIELD_SECTION_CLASS =
  'signup-2026-mobile-section px-6 py-5';
export const MOBILE_TEXTAREA_SECTION_CLASS =
  'signup-2026-mobile-section pl-6 pr-4 pt-5';
